import './App.css';
import '@fontsource/inter';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from './Components/NavBar';
import Footer from './Components/Footer';
import { Analytics } from '@vercel/analytics/react';
import Home from './Pages/Home';
import LoginPage from './Pages/LoginPage'
import RSVPStatusPage from './Pages/RSVPStatusPage';
import RegisterPage from './Pages/RegisterPage';
import PreviewPage from './Pages/PreviewPage';
import { StudioProvider } from './Context/StudioContext';
import { AuthProvider } from './Context/AuthContext';
import StudioLayout from './Components/CardStudio/StudioLayout';
import ActualCardRender from './Components/CardView/ActualCardRender';
import InvitationCardRender from './Components/CardView/InvitationCardRender';
import DesignPreviewRender from './Components/Designs/DesignPreviewRender';
import CatalogPage from './Pages/CatalogPage';
import ContactUs from './Pages/ContactUs';
import UserProfilePage from './Pages/UserProfilePage';
import AdminLoginPage from './Pages/AdminLoginPage';
import AdminDashboard from './Pages/AdminDashboard';
import DashboardPage from './Pages/DashboardPage';
import PhotoboothPage from './Pages/PhotoboothPage';


const theme = createTheme({
  typography: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, // MUI default font
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#55C2C3', // focus border
            },
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#55C2C3', // label color when focused
          },
        },
      },
    },
  },
});

function App() {
  return (

    <Router>
      <div
        className="App"
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <ThemeProvider theme={theme}>
          <CssBaseline /> {/* Ensures consistent styling across browsers */}
          <AuthProvider>
            <NavBar />
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/preview/:cardId" element={<ActualCardRender />} />
                <Route path="/invitation/:slug/:uniqueCode" element={<InvitationCardRender />} />
                <Route path="/design-preview/:designCode" element={
                  <StudioProvider>
                    <DesignPreviewRender />
                  </StudioProvider>
                } />
                <Route path="/rsvpstatus/:cardId" element={<RSVPStatusPage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/profile" element={<UserProfilePage />} />

                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />

                <Route path="/dashboard/:uniqueCode" element={<DashboardPage />} />

                {/* Digital Photobooth — Premium only, guest-facing */}
                <Route path="/photobooth/:slug/:uniqueCode" element={<PhotoboothPage />} />

                {/* Studio Builder */}
                <Route path="/studio" element={
                  <StudioProvider>
                    <StudioLayout />
                  </StudioProvider>
                } />
              </Routes>
            </div>
          </AuthProvider>
          <Footer />
        </ThemeProvider>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
